import { TemplateRef, Type } from '@angular/core';

export class WidgetItem {
    constructor(public component: Type<any>, public stateOptions: any, public data: any, public variable: any) { }
}


export class WidgetReportItem {
    constructor(public component: Type<any>, public data: any) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/widget/widget-item.ts